
import { addLoadingEffect, hideLoadingEffect } from '../utils/func.js'
import { showLoadingModal, hideLoadingModal } from '../transitions/show-loading-modal.js'
import { __sendVisit } from '../components/send-visit.js'
// import { triggerMatomo } from '../components/trigger-matomo'

const vm = this


export const transitions = [
  {
    name: 'default',
    enter ({ current, next, trigger }) {

      // document.querySelector('body').classList.remove('noScroll')
      // next.container.classList.remove('barba-container--fadeout')
      // next.container.classList.toggle('barba-container--fadein')

      console.info('enter: transition')
      //current.container.classList.toggle('is-loading')
      // hideLoadingEffect()
    },
    after ({ current, next, trigger }) {

      // document.querySelector('body').classList.remove('noScroll')
      // next.container.classList.remove('barba-container--fadeout')
      // next.container.classList.toggle('barba-container--fadein')

      console.info('after: transition')

      hideLoadingModal()
      //document.querySelector('body').classList.remove('Body--IsLoading')
    }
  },
  {
    name: 'toChart',
    to: {

      // define rule based on multiple namespaces
      namespace: [
        'chart'
      ]
    },
    leave ({ current, next, trigger }) {
      // const done = this.async()
      // vm.nextWorkAnimation().then(() => {
      //   done()
      // })
      console.info('nextToChart: transition')
    },
    enter ({ current, next, trigger }) {
      // window.scrollTo(0, 0)
      console.info('EnterChart: transition')
    },
    after ({ current, next, trigger }) {

      // document.querySelector('body').classList.remove('noScroll')
      // next.container.classList.remove('barba-container--fadeout')
      // next.container.classList.toggle('barba-container--fadein')

      console.info('after: transition')

      hideLoadingModal()
      //document.querySelector('body').classList.remove('Body--IsLoading')
    }
  },
  {
    name: 'toCart',
    to: {
      // define rule based on multiple namespaces
      namespace: [
        'reviewCart'
      ]
    },
    leave ({ current, next, trigger }) {
      console.info('nextToCart: transition')
    },
    enter ({ current, next, trigger }) {
      // window.scrollTo(0, 0)
      console.info('EnterCart: transition')
    },
    after ({ current, next, trigger }) {
      hideLoadingModal()
      __sendVisit()
      console.info('afterEnterCart: __sendVisit done')
      // triggerMatomo(window.myvars.scheduleEid, 'review-cart')
    }
  },
  {
    name: 'toConfirmation',
    to: {
      namespace: [
        'confirmation'
      ]
    },
    leave ({ current, next, trigger }) {
      // console.info('nextToConfirmation: transition')
    },
    enter ({ current, next, trigger }) {
      // console.info('EnterConfirmation: transition')
    },
    after ({ current, next, trigger }) {
      hideLoadingModal()
      __sendVisit()
      // console.info('afterEnterConfirmation: __sendVisit done')
      // triggerMatomo(window.myvars.scheduleEid, 'confirmation')
    }
  }
]
